module.exports = __webpack_public_path__ + "img/icon3.79939263.png";